import React, {Component} from 'react';
import PropTypes from 'prop-types';
import ReduxDataTable from './../../redux_data_table/ReduxDataTable';
import i18next from 'i18next';
import * as viewUtils from './../../../utils/view-utils';
import SortableDate from '../../utils/SortableDate';
import JsonDialog from '../../utils/JsonDialog';

class LogsKeyCreationList extends Component {
  constructor(props) {
    super(props);

    this.jsonDialogId = 'json-dialog';

    this.showContent = this.showContent.bind(this);
  }

  truncateText(text, length) {
    if (!text) {
      return '';
    }

    if (text.length <= length) {
      return text;
    }

    return text.substring(0, length) + '\u2026';
  }

  showContent(jsonData) {
    const modalProps = {
      dialogId: this.jsonDialogId,
      jsonData: jsonData,
    };
    this.modalDialog = viewUtils.showModal(
        JsonDialog,
        this.jsonDialogId,
        modalProps,
    );
  }

  render() {
    return (
      <div className="table-container">
        <ReduxDataTable {...this.props} notSortable={[0, 8, 9, 10]}>
          <thead>
            <tr role="row" className="odd heading">
              <th>ID</th>
              <th data-sort="siteId">{i18next.t('logs.key_creation.attributes.site_id')}</th>
              <th data-sort="userId">{i18next.t('logs.key_creation.attributes.user_id')}</th>
              <th data-sort="username">{i18next.t('logs.key_creation.attributes.username')}</th>
              <th data-sort="reservationId">{i18next.t('logs.key_creation.attributes.reservation_id')}</th>
              <th data-sort="externalReservationId">{i18next.t('logs.key_creation.attributes.ext_reservation_id')}</th>
              <th data-sort="workflowStep">{i18next.t('logs.key_creation.attributes.workflow')}</th>
              <th data-sort="eventTime">{i18next.t('logs.key_creation.attributes.timestamp')}</th>
              <th>{i18next.t('logs.key_creation.attributes.message')}</th>
              <th>{i18next.t('logs.key_creation.attributes.original_key')}</th>
              <th>{i18next.t('logs.key_creation.attributes.reservation_data')}</th>
              <th hidden={true}>{i18next.t('logs.key_creation.attributes.reservation_data')}</th>
            </tr>
          </thead>
          <tbody>
            {
              this.props.logs.map((log) => {
                return (
                  <tr key={log.id}>
                    <td>{log.id}</td>
                    <td>{log.siteId}</td>
                    <td>{log.userId}</td>
                    <td>{log.username}</td>
                    <td>{log.reservationId}</td>
                    <td>{log.externalReservationId}</td>
                    <td>{log.workflowStep}</td>
                    <td><SortableDate dateMillis={parseInt(log.eventTime, 10)}/></td>
                    <td>{log.message}</td>
                    <td>{log.originalKeyIdentifier}</td>
                    <td hidden={true}>{log.reservationData}</td>
                    <td onClick={() => this.showContent(log.reservationData)}>{this.truncateText(log.reservationData, 50)}</td>
                  </tr>
                );
              })
            }
          </tbody>
        </ReduxDataTable>
      </div>
    );
  }
}

LogsKeyCreationList.propTypes = {
  logs: PropTypes.array,
};

export default LogsKeyCreationList;
